var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticClass: "history-variable-block",
          class: { noSliderBlock: !_vm.slider },
          attrs: { id: _vm.elementId }
        },
        [
          _c(
            "b-col",
            {
              class: { "pb-2": _vm.verticalMode, "text-center": _vm.centered },
              attrs: {
                cols: "12",
                md: _vm.labelColumnSize,
                lg: _vm.labelColumnSize
              }
            },
            [
              _c("span", { staticClass: "d-inline-block history-label" }, [
                _vm._v(_vm._s(_vm.getLabel)),
                _c("br"),
                _vm.date && _vm.inputDisabled && _vm.slider && !_vm.hideDate
                  ? _c("span", { staticClass: "d-inline-block small" }, [
                      _vm._v("(" + _vm._s(_vm.getFormattedDate) + ")")
                    ])
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              attrs: {
                cols:
                  !_vm.editOrGraphsVisible || _vm.slider
                    ? 12
                    : !_vm.inputDisabled
                    ? 10
                    : 6,
                md: _vm.valueColumnSize,
                lg: _vm.valueColumnSize
              }
            },
            [
              !_vm.alreadySavedDailyVariable
                ? _c(
                    "div",
                    [
                      _vm.inputDisabled && !_vm.slider
                        ? _c(
                            "span",
                            { staticClass: "history-variable-value" },
                            [_vm._v(_vm._s(_vm.localizedInputValue))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isBlood && !_vm.inputDisabled
                        ? _c("base-select", {
                            attrs: {
                              placeholder: _vm.$t("selectOneOption"),
                              label: "name",
                              valueProp: "id",
                              searchable: "",
                              filtered: "",
                              options: _vm.bloodTypes
                            },
                            model: {
                              value: _vm.processedValue,
                              callback: function($$v) {
                                _vm.processedValue = $$v
                              },
                              expression: "processedValue"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isBlood &&
                      !_vm.inputDisabled &&
                      !_vm.variableValuesAreKeyPair &&
                      !_vm.slider
                        ? _c("b-form-input", {
                            staticClass: "d-inline-block",
                            attrs: {
                              size: "sm",
                              id: _vm.id,
                              placeholder: _vm.placeholder
                            },
                            model: {
                              value: _vm.localizedInputValue,
                              callback: function($$v) {
                                _vm.localizedInputValue = $$v
                              },
                              expression: "localizedInputValue"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.slider
                        ? _c("clinic-history-variable-slider", {
                            attrs: {
                              value: _vm.localizedInputValue,
                              name: _vm.name,
                              variableName: _vm.variableName,
                              rawData: _vm.rawData,
                              disabled:
                                !_vm.editable || _vm.alreadySavedDailyVariable,
                              emojiType: _vm.VARIABLES_WITH_EMOJI_INPUT.includes(
                                _vm.name
                              )
                            },
                            on: { save: _vm.emitSave }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.getMeasureUnit))]),
                      _vm._v(" "),
                      _vm.date && _vm.inputDisabled && !_vm.slider
                        ? _c("span", { staticClass: "d-inline-block small" }, [
                            _vm._v("(" + _vm._s(_vm.getFormattedDate) + ")")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass: "overlapping-slider-text",
                      class: { "text-center": _vm.centered }
                    },
                    [
                      _c("span", { staticClass: "small" }, [
                        _vm._v(
                          "\n  " +
                            _vm._s(
                              _vm.$tc(
                                "clinic-history.already-saved-today-variable",
                                _vm.daysRemaining,
                                {
                                  days: _vm.frequencyDays,
                                  daysRemaining: _vm.daysRemaining
                                }
                              )
                            ) +
                            "\n"
                        )
                      ])
                    ]
                  )
            ]
          ),
          _vm._v(" "),
          _vm.editOrGraphsVisible
            ? _c(
                "b-col",
                {
                  attrs: { cols: !_vm.inputDisabled ? 2 : 6, md: "3", lg: "2" }
                },
                [
                  _vm.editable && _vm.inputDisabled && !_vm.slider
                    ? _c("base-icon", {
                        staticClass: "d-inline-block clickable icon",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/pencil-icon-blue.svg"
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.edit.apply(null, arguments)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.inputDisabled
                    ? _c("base-icon", {
                        staticClass: "d-inline-block clickable icon",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/tick-icon-blue.svg",
                          color: _vm.BLUE_COLOUR
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.save.apply(null, arguments)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.graphEnabled && _vm.inputDisabled
                    ? _c("base-icon", {
                        staticClass: "d-inline-block clickable icon",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/graph-icon-blue.svg"
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.showChart.apply(null, arguments)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editable &&
                  _vm.inputDisabled &&
                  !_vm.isBlood &&
                  _vm.showTrackingButton
                    ? _c("base-icon", {
                        staticClass: "d-inline-block clickable icon",
                        attrs: {
                          green: _vm.rawData.trackingCreated,
                          gray: !_vm.rawData.trackingCreated,
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/bell.svg"
                        },
                        nativeOn: {
                          click: function($event) {
                            _vm.showReminder = true
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-modal",
        {
          on: {
            hidden: function($event) {
              _vm.showChartModal = false
            }
          },
          model: {
            value: _vm.showChartModal,
            callback: function($$v) {
              _vm.showChartModal = $$v
            },
            expression: "showChartModal"
          }
        },
        [
          _c("clinic-history-variable-chart", {
            attrs: {
              variableName: _vm.variableName,
              coloringPoints: _vm.VARIABLES_WITH_COLOUR_RANGE.includes(
                _vm.name
              ),
              dynamicXAxis: _vm.VARIABLES_WITH_DYNAMIC_X_AXIS.includes(
                _vm.name
              ),
              oneValuePerDay:
                _vm.DAILY_VARIABLES.includes(_vm.name) || _vm.daily,
              maxValue: _vm.VARIABLES_WITH_COLOUR_RANGE.includes(_vm.name)
                ? 10
                : null
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("history-variable-reminder", {
        attrs: {
          varName: _vm.variableName,
          created: _vm.rawData.trackingCreated
        },
        on: {
          reminderCreated: function($event) {
            _vm.rawData.trackingCreated = $event
          }
        },
        model: {
          value: _vm.showReminder,
          callback: function($$v) {
            _vm.showReminder = $$v
          },
          expression: "showReminder"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26f5f3ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26f5f3ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ClinicHistoryVariable.vue
// module id = 2701
// module chunks = 31 34 38 39 147